/* Heavenly Crafted — header behaviour.
   1. Keeps the header below any sticky announcement bar (measured, not hard-coded)
   2. Menu / search / cart layers
   3. Predictive search (Shopify /search/suggest.json)
   4. Cart drawer (Shopify /cart.js + /cart/change.js) with live badge
   Every interaction has a plain-link fallback, so nothing breaks if this fails. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var hdr = d.getElementById('gnHdr');
  if (!hdr) return;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ───────── 1. announcement-bar offset ───────── */
  function fixedBarBottom() {
    var maxB = 0, seen = [];
    var xs = [8, Math.round(window.innerWidth / 2), window.innerWidth - 8];
    for (var i = 0; i < xs.length; i++) {
      var els = d.elementsFromPoint ? d.elementsFromPoint(xs[i], 1) : [];
      for (var j = 0; j < els.length; j++) {
        var n = els[j];
        while (n && n !== d.body && n !== root) {
          if (n === hdr || hdr.contains(n)) break;
          if (n.classList && n.classList.contains('gn-layer')) break;
          var pos = getComputedStyle(n).position;
          if (pos === 'fixed' || pos === 'sticky') {
            if (seen.indexOf(n) === -1) {
              seen.push(n);
              var r = n.getBoundingClientRect();
              if (r.top <= 2 && r.height > 0 && r.height < 160 && r.width >= window.innerWidth * 0.6) {
                maxB = Math.max(maxB, r.bottom);
              }
            }
            break;
          }
          n = n.parentElement;
        }
      }
    }
    return Math.max(0, Math.round(maxB));
  }
  function existingTopOffset() {
    var b = getComputedStyle(d.body), h = getComputedStyle(root);
    return (parseFloat(b.paddingTop) || 0) + (parseFloat(b.marginTop) || 0) +
           (parseFloat(h.paddingTop) || 0) + (parseFloat(h.marginTop) || 0);
  }
  var spacer = null, lastH = -1;
  function applyOffset() {
    var H = fixedBarBottom();
    if (H === lastH) return;
    lastH = H;
    root.style.setProperty('--gn-app-bar', H + 'px');
    root.style.setProperty('--gn-hdr-h', hdr.offsetHeight + 'px');
    // if the bar's app hasn't already pushed the page down, push it ourselves
    var need = Math.max(0, H - existingTopOffset());
    if (!spacer) {
      spacer = d.getElementById('gnAppSpacer');
      if (!spacer) {
        spacer = d.createElement('div');
        spacer.id = 'gnAppSpacer';
        spacer.setAttribute('aria-hidden', 'true');
        hdr.parentNode.insertBefore(spacer, hdr.nextSibling);
      }
    }
    spacer.style.height = need + 'px';
  }
  var offT;
  function scheduleOffset() { clearTimeout(offT); offT = setTimeout(function(){ lastH = -1; applyOffset(); }, 60); }
  applyOffset();
  window.addEventListener('load', scheduleOffset);
  window.addEventListener('resize', scheduleOffset);
  [300, 900, 2000, 4000, 7000].forEach(function (t) { setTimeout(applyOffset, t); });
  if (window.MutationObserver) {
    var mo = new MutationObserver(scheduleOffset);
    mo.observe(d.body, { childList: true });
    setTimeout(function () { mo.disconnect(); }, 12000);
  }

  /* ───────── 1b. desktop links never collide with the buttons ───────── */
  function fitLinks() {
    var ul = hdr.querySelector('.gn-links');
    if (!ul) return;
    var items = [].slice.call(ul.children);
    items.forEach(function (li) { li.style.display = ''; });
    if (getComputedStyle(ul).display === 'none') return;
    var order = items.slice().sort(function (a, b) { return (+a.getAttribute('data-prio') || 0) - (+b.getAttribute('data-prio') || 0); });
    for (var i = 0; i < order.length - 1 && ul.scrollWidth > ul.clientWidth + 1; i++) order[i].style.display = 'none';
  }
  var fitT;
  function scheduleFit() { clearTimeout(fitT); fitT = setTimeout(fitLinks, 80); }
  fitLinks();
  window.addEventListener('resize', scheduleFit);
  window.addEventListener('load', fitLinks);
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(fitLinks);

  /* ───────── 2. layers ───────── */
  var openLayer = null, lastFocus = null;
  function setExpanded(id, v) {
    var btns = d.querySelectorAll('[data-gn-open="' + id + '"]');
    for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-expanded', v ? 'true' : 'false');
  }
  function open(id) {
    var L = d.getElementById(id);
    if (!L) return false;
    if (openLayer && openLayer !== L) close(openLayer, true);
    lastFocus = d.activeElement;
    L.hidden = false;
    root.classList.add('gn-lock');
    requestAnimationFrame(function () { L.classList.add('is-open'); });
    setExpanded(id, true);
    openLayer = L;
    var f = L.querySelector('input[type=search]') || L.querySelector('.gn-x');
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 60);
    return true;
  }
  function close(L, quick) {
    L = L || openLayer;
    if (!L) return;
    L.classList.remove('is-open');
    setExpanded(L.id, false);
    root.classList.remove('gn-lock');
    if (openLayer === L) openLayer = null;
    var done = function () { if (!L.classList.contains('is-open')) L.hidden = true; };
    quick ? done() : setTimeout(done, 300);
    if (!quick && lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-gn-open]');
    if (o) { e.preventDefault(); var id = o.getAttribute('data-gn-open'); (openLayer && openLayer.id === id) ? close() : open(id); return; }
    var c = e.target.closest && e.target.closest('[data-gn-close]');
    if (c) { e.preventDefault(); close(); return; }
    var a = e.target.closest && e.target.closest('.gn-menu a');
    if (a) close(null, true);
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openLayer) close();
    if (e.key === 'Tab' && openLayer) {
      var f = openLayer.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ───────── helpers ───────── */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var currency = 'USD';
  function money(cents) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format((cents || 0) / 100); }
    catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  }
  function img(u, w) {
    if (!u) return '';
    if (typeof u === 'object') u = u.url || u.src || '';
    if (!u) return '';
    if (/^(blob|data):/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160);
  }

  /* ───────── 3. predictive search ───────── */
  var sIn = d.getElementById('gnSearchInput'), sRes = d.getElementById('gnSearchRes'), sT, sCtl;
  function searchAll(q) { return ROOT + 'search?type=product,article&q=' + encodeURIComponent(q); }
  if (sIn && sRes) {
    sIn.addEventListener('input', function () {
      clearTimeout(sT);
      var q = sIn.value.trim();
      if (q.length < 2) { sRes.innerHTML = ''; return; }
      sT = setTimeout(function () { runSearch(q); }, 220);
    });
  }
  function runSearch(q) {
    if (sCtl && sCtl.abort) sCtl.abort();
    sCtl = window.AbortController ? new AbortController() : null;
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { signal: sCtl ? sCtl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (data) {
        var R = (data && data.resources && data.resources.results) || {};
        var html = '';
        var P = R.products || [], C = R.collections || [], A = R.articles || [];
        if (P.length) {
          html += '<div class="gn-sr-h">Products</div>';
          P.forEach(function (p) {
            var pr = p.price != null ? p.price : (p.price_min != null ? p.price_min : '');
            var prTxt = pr === '' ? '' : (String(pr).indexOf('.') > -1 || String(pr).indexOf('$') > -1 ? (String(pr).charAt(0) === '$' ? pr : '$' + pr) : money(pr));
            html += '<a class="gn-sr-row" href="' + esc(p.url) + '"><span class="gn-sr-img">' +
              (p.image || p.featured_image ? '<img src="' + esc(img(p.image || p.featured_image, 120)) + '" alt="" loading="lazy">' : '') +
              '</span><span class="gn-sr-t">' + esc(p.title) + '</span><span class="gn-sr-p">' + esc(prTxt) + '</span></a>';
          });
        }
        if (C.length) {
          html += '<div class="gn-sr-h">Collections</div>';
          C.forEach(function (c) { html += '<a class="gn-sr-row" href="' + esc(c.url) + '"><span class="gn-sr-t">' + esc(c.title) + '</span></a>'; });
        }
        if (A.length) {
          html += '<div class="gn-sr-h">Case Notes</div>';
          A.forEach(function (a) { html += '<a class="gn-sr-row" href="' + esc(a.url) + '"><span class="gn-sr-t">' + esc(a.title) + '</span></a>'; });
        }
        if (!html) html = '<div class="gn-sr-empty">No matches yet for “' + esc(q) + '”. Press Enter to search everything.</div>';
        html += '<a class="gn-sr-all" href="' + esc(searchAll(q)) + '">See all results for “' + esc(q) + '”</a>';
        sRes.innerHTML = html;
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        sRes.innerHTML = '<a class="gn-sr-all" href="' + esc(searchAll(q)) + '">Search for “' + esc(q) + '”</a>';
      });
  }

  /* ───────── 4. cart badge + drawer ───────── */
  var cartLayer = d.getElementById('gnCart');
  var itemsEl = d.getElementById('gnCartItems');
  var subEl = d.getElementById('gnCartSub');
  var checkoutEl = cartLayer ? cartLayer.querySelector('.gn-checkout') : null;
  var shopUrl = (d.querySelector('.gn-feat-link') || {}).href || (ROOT + 'collections/all');

  function setCount(n, bump) {
    n = n || 0;
    var els = d.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) els[i].textContent = n;
    var btns = d.querySelectorAll('.gn-cart-btn');
    for (var k = 0; k < btns.length; k++) {
      btns[k].classList.toggle('has-items', n > 0);
      btns[k].setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      if (bump) { btns[k].classList.remove('gn-bump'); void btns[k].offsetWidth; btns[k].classList.add('gn-bump'); }
    }
  }
  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); });
  }
  function renderCart(c) {
    if (!itemsEl) return;
    currency = c.currency || currency;
    setCount(c.item_count);
    if (subEl) subEl.textContent = money(c.total_price);
    if (checkoutEl) checkoutEl.setAttribute('aria-disabled', c.item_count ? 'false' : 'true');
    if (!c.item_count) {
      itemsEl.innerHTML = '<div class="gn-cart-empty">Your cart is empty.<br><a class="p6-btn gold" href="' + esc(shopUrl) + '">Shop All</a></div>';
      return;
    }
    var h = '';
    c.items.forEach(function (it, i) {
      var line = i + 1;
      var v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      h += '<div class="gn-ci">' +
        '<a class="gn-ci-img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 180)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="gn-ci-t" href="' + esc(it.url) + '">' + esc(it.product_title || it.title) + '</a>' +
        (v ? '<div class="gn-ci-v">' + esc(v) + '</div>' : '') +
        '<div class="gn-ci-row"><span class="gn-qty">' +
        '<button type="button" data-gn-q="' + line + '" data-gn-n="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
        '<span aria-label="Quantity">' + it.quantity + '</span>' +
        '<button type="button" data-gn-q="' + line + '" data-gn-n="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></span>' +
        '<button type="button" class="gn-ci-rm" data-gn-q="' + line + '" data-gn-n="0">Remove</button></div></div>' +
        '<div class="gn-ci-p">' + money(it.final_line_price) + '</div></div>';
    });
    itemsEl.innerHTML = h;
  }
  function loadCart() {
    if (itemsEl && !itemsEl.children.length) itemsEl.innerHTML = '<p class="gn-cart-loading">Loading cart…</p>';
    return getCart().then(renderCart).catch(function () {
      if (itemsEl) itemsEl.innerHTML = '<div class="gn-cart-empty">Couldn’t load the cart here.<br><a class="p6-btn gold" href="' + ROOT + 'cart">Open Cart</a></div>';
    });
  }
  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-gn-q]');
      if (!b) return;
      e.preventDefault();
      itemsEl.classList.add('is-busy');
      fetch(ROOT + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(b.getAttribute('data-gn-q'), 10), quantity: Math.max(0, parseInt(b.getAttribute('data-gn-n'), 10)) })
      })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (c) { renderCart(c); d.dispatchEvent(new CustomEvent('gn:cart-changed', { detail: c })); })
        .catch(loadCart)
        .then(function () { itemsEl.classList.remove('is-busy'); });
    });
  }
  // cart button opens the drawer; modified clicks / no-JS still go to /cart
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-gn-cart-open]');
    if (!a || !cartLayer) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    e.preventDefault();
    open('gnCart');
    loadCart();
  });
  // product page add-to-cart announces itself here
  d.addEventListener('gn:cart-updated', function (e) {
    var c = e.detail;
    if (c && typeof c.item_count === 'number') { setCount(c.item_count, true); if (openLayer === cartLayer) renderCart(c); }
    else getCart().then(function (cc) { setCount(cc.item_count, true); }).catch(function () {});
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) getCart().then(function (c) { setCount(c.item_count); }).catch(function () {});
  });
  window.GNCart = { open: function () { open('gnCart'); loadCart(); }, refresh: loadCart };
})();

/* Hero flashlight on TOUCH screens. The original effect (gospel-noir.js) listens for
   mousemove only, so phones and tablets never saw Jesus lit up. Mouse behaviour is untouched. */
(function () {
  'use strict';
  var d = document;
  var hero = d.querySelector('.hero'), mask = d.getElementById('heroMask'), pic = d.getElementById('heroPortrait');
  if (!hero || !mask || !pic) return;
  if (!(window.matchMedia && window.matchMedia('(hover: none)').matches)) return;   // mouse users keep the original
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function light(x, y, op) {
    mask.style.background = 'radial-gradient(circle 100px at ' + x + '% ' + y + '%, rgba(220,240,255,.1) 0%, transparent 100%), ' +
      'radial-gradient(circle 520px at ' + x + '% ' + y + '%, transparent 0%, rgba(2,3,10,.32) 42%, rgba(2,3,10,.92) 100%)';
    pic.style.opacity = op;
  }
  var REST_X = 72, REST_Y = 30;
  if (reduce) { light(REST_X, REST_Y, '.5'); }
  else {
    // one slow sweep across the evidence, settling on the portrait
    var t0 = null, dur = 2600;
    var ease = function (t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };
    var step = function (ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur), e = ease(k);
      var x = 18 + (REST_X - 18) * e, y = 70 - (70 - REST_Y) * e + Math.sin(k * Math.PI) * -8;
      light(x.toFixed(1), y.toFixed(1), (0.3 + 0.32 * Math.sin(k * Math.PI / 2)).toFixed(2));
      if (k < 1) requestAnimationFrame(step); else light(REST_X, REST_Y, '.55');
    };
    setTimeout(function () { requestAnimationFrame(step); }, 450);
  }
  // drag a finger over the hero to move the light
  hero.addEventListener('touchmove', function (e) {
    var t = e.touches[0], r = hero.getBoundingClientRect();
    light(((t.clientX - r.left) / r.width * 100).toFixed(1), ((t.clientY - r.top) / r.height * 100).toFixed(1), '.62');
  }, { passive: true });
  hero.addEventListener('touchend', function () { light(REST_X, REST_Y, '.55'); }, { passive: true });
})();
